import { FC, useState } from "react";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import useCapitalize from "../Adress/helpers/useCapitalize";
import { useGetFavoriteList } from "apps/CustomerPanel/Favorite/Pages/Ads/ServerSideStates";
import { Col, Drawer, Row, Typography } from "antd";
import AddOrUpdateFavoriteList from "apps/CustomerPanel/Favorite/Pages/Ads/Components/AddOrUpdateFavoriList";
import endPoints from "apps/CustomerPanel/Favorite/Pages/Ads/EndPoints";
import { useQueryClient } from "react-query";
import { PlusOutlined } from "@ant-design/icons";

const GeneralFavoriteList: FC<GeneralSelectInputs> = (props) => {
  const favoriteList = useGetFavoriteList();
  let { capitalize } = useCapitalize();
  const [isShowCreateListDrawer, setIsShowCreateListDrawer] = useState(false);
  const queryClient = useQueryClient();
  const { Text } = Typography;

  return (
    <>
      <Col
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
      >
        <Row gutter={[0, 5]}>
          <MazakaSelect
            name={props.name}
            xs={24}
            loading={favoriteList.isLoading || favoriteList.isFetching}
            disabled={
              favoriteList.isLoading ||
              favoriteList.isFetching ||
              props.disabled
            }
            className={props.className}
            showSearch={true}
            allowClear={props.allowClear || false}
            filterOption={(input, option: any) =>
              (option.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            label={props.label}
            options={
              favoriteList?.data?.data
                ? favoriteList.data.data.map((item: any) => {
                    return {
                      key: item.id,
                      value: item.id,
                      label: capitalize(item.name || " "),
                    };
                  })
                : []
            }
            placeholder={props.placeholder}
            mode={props.mode}
            onChange={props.onChange}
            value={props.value}
            rules={props.rules}
          />
          <Col xs={24}>
            <span
              className="!flex gap-1 !cursor-pointer "
              onClick={() => {
                setIsShowCreateListDrawer(true);
              }}
            >
              <PlusOutlined className="!text-xs !text-indigo-500" />
              <Text className="!text-xs !text-indigo-500">Yeni Liste Ekle</Text>
            </span>
          </Col>
        </Row>
      </Col>

      <Drawer
        open={isShowCreateListDrawer}
        onClose={() => {
          setIsShowCreateListDrawer(false);
        }}
      >
        <AddOrUpdateFavoriteList
          onFinish={(response:any) => {
            setIsShowCreateListDrawer(false);
            queryClient.resetQueries({
              queryKey: endPoints.getFavoriteListFilter,
              exact: false,
            });
            props.form.setFieldValue(props.name,response?.data?.id)
          }}
        />
      </Drawer>
    </>
  );
};

export default GeneralFavoriteList;
